var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"group-editor-permissions"}},[_c('ExpandableTable',{attrs:{"children":_vm.permissions_hierarchy,"fields":_vm.permissions_fields,"highlightable":""},on:{"content_link_clicked":_vm.content_link_clicked,"cell_value_changed":_vm.permissions_checkbox_changed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }